import React from "react";
const practiceAreas = [{
  number: "01",
  title: "Bilişim Hukuku",
  description: "Kişisel verilerin korunması, internet ortamındaki içerik ve işlemler, bilişim sistemlerinin kullanımı ve bilişim suçlarından doğan hukuki meseleler bu alan kapsamında değerlendirilir. Sosyal medya ve çevrimiçi platformlardaki içerikler, hesap ve erişim sorunları, dijital sözleşmeler, elektronik ortamda gerçekleştirilen işlemler ile yapay zekâ uygulamalarının doğurduğu hukuki sorunlar da bu kapsamda ele alınabilir."
}, {
  number: "02",
  title: "Medeni Hukuk",
  description: "Kişiler hukuku, aile hukuku, miras hukuku, taşınmazlar ve özel hukuk ilişkilerinden doğan uyuşmazlıkların mevzuat ve içtihat çerçevesinde ele alınması."
}, {
  number: "03",
  title: "Borçlar Hukuku",
  description: "Sözleşmelerin kurulması, yorumlanması ve sona ermesi; alacak-borç ilişkileri, tazminat talepleri ve haksız fiilden doğan uyuşmazlıklar."
}, {
  number: "04",
  title: "Ceza Hukuku",
  description: "Soruşturma ve kovuşturma evrelerinde şikâyet, savunma, delil değerlendirmesi, duruşma hazırlığı ve yargılama süreçlerine ilişkin işlemler."
}, {
  number: "05",
  title: "Ticaret Hukuku",
  description: "Ticari sözleşmeler, şirketlerin günlük hukuki işlemleri, ortaklık ilişkileri, şirket danışmanlığı ve ticari uyuşmazlıklara ilişkin çalışmalar."
}, {
  number: "06",
  title: "Kat Mülkiyeti Hukuku",
  description: "Apartman, site ve toplu yapı yönetimi; yönetim planı, aidat ve ortak giderler, kat malikleri kurulu kararları ve ilgili uyuşmazlıklar."
}];
export default function OurDigitalDna() {
  return <section data-section-id="223851" id="faaliyet-alanlari" className="bg-[#f4efe5] text-[#111111]">
      <div className="mx-auto grid max-w-[1320px] gap-8 px-5 py-14 sm:px-8 md:py-18 lg:grid-cols-[minmax(0,0.31fr)_minmax(0,0.69fr)] lg:gap-14 lg:px-10 lg:py-22">
        <div className="min-w-0 border-t border-[#111111]/16 pt-7 lg:sticky lg:top-28 lg:self-start">
          <h2 className="font-serif text-[clamp(2.55rem,5vw,5.2rem)] font-normal leading-[0.96] tracking-[-0.03em] text-[#111111]">
            Faaliyet Alanları
          </h2>
        </div>

        <div className="min-w-0 border-t border-[#111111]/18">
          {practiceAreas.map((area, i) => <article key={area.number} data-index={i} className="grid min-w-0 gap-4 border-b border-[#111111]/16 py-5 sm:grid-cols-[54px_minmax(0,1fr)] md:py-[1.35rem]">
              <div className="font-mono text-[11px] leading-7 tracking-[0.18em] text-[#111111]/34">{area.number}</div>
              <div className="min-w-0">
                <h3 className="font-serif text-[clamp(1.55rem,2.25vw,2.22rem)] font-normal leading-tight text-[#111111]">
                  {area.title}
                </h3>
                <p className="mt-3 max-w-[48rem] font-sans text-sm leading-7 text-[#111111]/68 sm:text-[15px]">
                  {area.description}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}